import React from 'react';
import {Link} from 'react-router-dom';
import {TaskAssignmentStateEnum, TaskTypeEnum} from 'src/api/ProactApiClient';
import {Center} from 'src/design/atoms/Center';
import {Group} from 'src/design/atoms/Group';
import {Loader} from 'src/design/atoms/Loader';
import {NavAnchor} from 'src/design/atoms/NavAnchor';
import {Stack} from 'src/design/atoms/Stack';
import {Text} from 'src/design/atoms/Text';
import {InfoAlert} from 'src/design/molecules/InfoAlert';
import {useAppSelector} from 'src/redux/hooks';
import {useGetTaskAssignmentsListQuery} from 'src/redux/queries/taskAssignment';
import {PathUtility} from 'src/shared/constants/PathBuilder';

export interface RelatedApprovalsBannerProps {
  formId?: number;
}

export const RelatedApprovalsBanner: React.FC<RelatedApprovalsBannerProps> = ({
  formId,
}) => {
  const {session} = useAppSelector(state => state.session);
  const userId = session?.user?.id;

  const {data, isLoading, isError} = useGetTaskAssignmentsListQuery(
    {
      taskType: TaskTypeEnum.Approval,
      assignedToUserId: userId,
      assignmentStates: [
        TaskAssignmentStateEnum.Assigned,
        TaskAssignmentStateEnum.Viewed,
      ],
      filterFormId: formId,
      start: 0,
      length: 10,
    },
    {skip: !userId || !formId, refetchOnMountOrArgChange: true}
  );

  if (isLoading) {
    return (
      <Center py="xs">
        <Loader size="xs" />
      </Center>
    );
  }

  const rows = data?.data ?? [];
  if (isError || rows.length === 0) return null;

  return (
    <InfoAlert
      title={rows.length === 1 ? 'Approval requested' : 'Approvals requested'}
      mb="sm">
      <Stack gap="xs">
        {rows.map(row => (
          <Group key={row.id} gap="xs" wrap="wrap" align="center">
            <Text size="sm">{row.taskDefinition.subject}</Text>
            <NavAnchor
              component={Link}
              text="Open approval"
              to={PathUtility.ViewTaskAssignment(TaskTypeEnum.Approval, row.id)}
            />
          </Group>
        ))}
      </Stack>
    </InfoAlert>
  );
};
